import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './UserUpdate.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';

import MyTooltip from '../components/Utilities/MyTooltip';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';
import {MyGreenPressButton} from '../components/Utilities/MyPressButton';

export default function UserUpdate(prop) {	
	const navigate = useNavigate();

	let passUsernames = prop.usernames;
	const [usernames, setUsernames] = useState((passUsernames) ? passUsernames : []);
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [usernameLoaded, setUsernameLoaded] = useState(false);
	
	
	const [hardPasswordOverride, setHardPasswordOverride] = useState(false);
	
	const [userObjs, setUserObjs] = useState([]);
	const [errorMessage, setErrorMessage] = useState("")
	
	const [usernameStr, setUsernameStr] = 
		useState((passUsernames) ? passUsernames.join('\n'):"")
	const [nicknameStr, setNicknameStr] = useState("")
	const [phoneStr, setPhoneStr] = useState("")
	const [passwordStr, setPasswordStr] = useState("")
	
	
	const fetchData = async () => {		
	
		await loadUsername();
		
		setFetchCompleted(true);
	}
	
	const loadUsername = async () => {		
		setErrorMessage("");
		let newUsername = usernameStr.trim().split(/\r\n|\n|\r/);
		if (newUsername.length == 0) {
			return;
		}
		
		let hasDuplicate = false;
		let duplicateUserName = [];
		let existingName = [];
		for(let nc of newUsername) {
			if (existingName.includes(nc)) {
				hasDuplicate = true;
				duplicateUserName.push(nc);
			} else {
				existingName.push(nc);
			}
		}
		if (hasDuplicate) {
			setErrorMessage("Duplicate User name " + duplicateUserName);
			return;
		}
		
		let obj = { names:newUsername }
		
		let res = await postData("schoolApi/getUserByUsernames", obj, navigate); 
		let data = res.data;
		let nameMap = [];
		let hasInvalidUsers = false;
		let invalidUsers = [];
		for(let d of data) {
			nameMap[d.username.toLowerCase()] = d;
		}
		
		let tmpUserObjs = [];
		for(let un of newUsername) {
			let lun = un.toLowerCase();
			if (nameMap[lun] && nameMap[lun].id) {
				tmpUserObjs.push(nameMap[lun]);
			} else {
				hasInvalidUsers = true;
				invalidUsers.push(un);
			}
			
		}
		
		if (hasInvalidUsers) {			
			setErrorMessage("User Not Found " + invalidUsers.join(','));
			return;
		}
		
		
		setUserObjs(tmpUserObjs);
		setUsernameLoaded(true);
	}
	
	
	const loadNickname = async () => {
		setErrorMessage("");
		let newNickname = nicknameStr.trim().split(/\r\n|\n|\r/);
		if (newNickname.length == 0) {
			return;
		}
		
		if (newNickname.length != userObjs.length) {
			setErrorMessage("user X nickname counting not match");
			return;
		}
		
		for(let i = 0; i < userObjs.length; i++) {
			userObjs[i].overrideNickname = newNickname[i];
		}
		
		setUserObjs([...userObjs]);
	}
	const loadPhone = async () => {
		setErrorMessage("");
		let newPhone = phoneStr.trim().split(/\r\n|\n|\r/);
		if (newPhone.length == 0) {
			return;
		}
		
		if (newPhone.length != userObjs.length) {
			setErrorMessage("user X phone counting not match");
			return;
		}
		
		for(let i = 0; i < userObjs.length; i++) {
			userObjs[i].overridePhone = newPhone[i];
		}
		
		setUserObjs([...userObjs]);
	}
	
	const loadPassword = async () => {
		setErrorMessage("");
		let newPassword = passwordStr.trim().split(/\r\n|\n|\r/);
		if (newPassword.length == 0) {
			return;
		}
		
		if (newPassword.length != userObjs.length) {
			setErrorMessage("user X password counting not match");
			return;
		}
		
		for(let i = 0; i < userObjs.length; i++) {
			userObjs[i].overridePassword = newPassword[i];
		}
		
		setUserObjs([...userObjs]);
	}
	
	const loadDefaultPassword = async () => {
		let pArray = [];
		for(let u of userObjs) {
			if (u.userGroup == 3) {
				u.overridePassword = "a12345678";
				pArray.push("a12345678");
			} else {
				u.overridePassword = "12345678";
				pArray.push("12345678");
			}
		}
		setErrorMessage("");
		setUserObjs([...userObjs]);
		setPasswordStr(pArray.join('\n'));
	}
	
	
	const batchUpdateUserBasic = async () => {
		let userNicknameParams = [];
		let userPhoneParams = [];
		let userPasswordParams = [];
		for (let u of userObjs) {
			if (u.nickname != u.overrideNickname) {
				if (u.overrideNickname) {
					userNicknameParams.push({id:u.id, nickname:u.overrideNickname});
				}
			}
			if (u.phone != u.overridePhone) {
				if (u.overridePhone) {
					userPhoneParams.push({id:u.id, phone:u.overridePhone});
				}
			}
			
			if (hardPasswordOverride) {
				if (u.overridePassword) {
					userPasswordParams.push({id:u.id, password:u.overridePassword});	
				}				
			} else if (!u.password) {
				if (u.overridePassword) {
					userPasswordParams.push({id:u.id, password:u.overridePassword});
				}
			}
		}
		
		if (userNicknameParams.length > 0) {
			let params = {data:userNicknameParams}
			await postData("customerApi/updateUsersNickname", params, navigate); 
		}
		
		if (userPhoneParams.length > 0) {
			let params = {data:userPhoneParams}
			await postData("customerApi/updateUsersPhone", params, navigate); 
		}
		
		if (userPasswordParams.length > 0) {
			let params = {data:userPasswordParams}
			await postData("customerApi/updateUsersPassword", params, navigate); 
		}
		
		await loadUsername();
		
	}
	
	useEffect(() => {
		if (usernames.length > 0) {
			fetchData();
		} else {			
			setFetchCompleted(true);
		}
	}, []);
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	return (<div className={s.mainHolder}>
		<div className={s.paramHolder}>
			<div style={{fontWeight:"bold", fontSize:"22px"}}>Update User</div>
			
			<GreenButton isEnabled={!errorMessage}
				clickedAction={()=>{
					batchUpdateUserBasic();
				}} bText="Update" />
			
			
			<div className={s.newLabel} style={{overflowWrap: "break-word"}}>{errorMessage}</div>
	
			<div style={{display:"flex", margin:"10px 0", gap:"10px", justifyContent:"center", flexWrap:"wrap"}}>
				<div style={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
					<div>username</div>
					<textarea style={{border:"1px solid #22222222", minWidth:"200px"}}  
						className={s.textAreaAuto} value={usernameStr} rows={5} wrap='off' onChange={(e) => setUsernameStr(e.target.value)}/>
						
					<div>
						<BlueButton isEnabled={usernameStr}
							clickedAction={()=>{
								loadUsername();
							}} bText="Load" />
					</div>
				</div>
				{
				(usernameLoaded) && (<div style={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
						<div>Nickname</div>
						<textarea style={{border:"1px solid #22222222", minWidth:"200px"}}  
							className={s.textAreaAuto} value={nicknameStr} rows={5} wrap='off' onChange={(e) => setNicknameStr(e.target.value)}/>
						<div>
							<BlueButton isEnabled={nicknameStr}
								clickedAction={()=>{
									loadNickname();								
								}} bText="Load" />
						</div>
					</div>)
				}		
				{(usernameLoaded) && (<div style={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
						<div>Phone</div>
						<textarea style={{border:"1px solid #22222222", minWidth:"200px"}}  
							className={s.textAreaAuto} value={phoneStr} rows={5} wrap='off' onChange={(e) => setPhoneStr(e.target.value)}/>
						<div>
							<BlueButton isEnabled={phoneStr}
								clickedAction={()=>{
									loadPhone();								
								}} bText="Load" />
						</div>
					</div>)
				}		
				{(usernameLoaded) && (<div style={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
						<div>Password</div>
				
						<textarea style={{border:"1px solid #22222222", minWidth:"200px"}}  
							className={s.textAreaAuto} value={passwordStr} rows={5} wrap='off' onChange={(e) => setPasswordStr(e.target.value)}/>
						<div style={{display:"flex", flexDirection:"column", textAlign:"center", gap:"10px"}}>
							<div style={{display:"flex", gap:"5px"}}>
								<BlueButton isEnabled={passwordStr}
									clickedAction={()=>{
										loadPassword();
									}} bText="Load" />
								<BlueButton isEnabled={true}
									clickedAction={()=>{
										loadDefaultPassword();
									}} bText="default password" />
							</div>
							<div style={{display:"flex", gap:"5px", alignItems:"center", justifyContent:"center"}}>
								<div style={{fontSize:"18px"}}>Hard Override</div>
								<div><MyGreenPressButton isPressed={hardPasswordOverride} clickedAction={()=>setHardPasswordOverride(p=>!p)} bText={(hardPasswordOverride) ? "ON" : "off"}/></div>
							</div>
							
						</div>
					</div>)
				}			
			</div>	
		</div>	
		
		<div className={s.rowHolder} style={{fontWeight:"bold"}}>
			<div style={{flexBasis:"80px"}}>Id</div>
			<div>username</div>
			<div>nickname</div>
			<div>New Name</div>
			<div>password</div>
			<div>New PD</div>
			<div>phone</div>
			<div>New Phone</div>
			<div>group</div>
			<div style={{flex:"1 1 200px", textAlign:"right"}}>organizations</div>
		</div>
	
		{
			userObjs.map((u, indexD)=>(<div key={indexD} className={s.rowHolder} style={(indexD % 2 == 0) ? {background:"#dae6e8"} :{}}>
				<div style={{flexBasis:"80px"}}>{u.id}</div>
				<div>{u.username}</div>
				<div>{u.nickname}</div>
				<div className={u.overrideNickname && (u.nickname != u.overrideNickname) ? s.boldImportant : ""}>{u.overrideNickname}</div>
				<div>{u.password}</div>
				<div className={u.overridePassword &&((hardPasswordOverride || !u.password)) ? s.boldImportant : ""}>{u.overridePassword}</div>
				<div>{u.phone}</div>
				<div className={u.overridePhone && (u.phone != u.overridePhone) ? s.boldImportant : ""}>{u.overridePhone}</div>
				<div>{displayUserGroup(u.userGroup)}</div>
				<div style={{flex:"1 1 200px", textAlign:"right"}}>{u.orgIds.join(',')}</div>
			</div>))
		}
	</div>);
	
}

const displayUserGroup = (userGroup) => {
	switch(userGroup) {
		case 3:
			return "teacher";
		case 4:
			return "parent";
		case 5:
			return "student";
	}
}